import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=0f0cc77a&scoped=true&"
import script from "./Item.vue?vue&type=script&lang=ts&"
export * from "./Item.vue?vue&type=script&lang=ts&"
import style0 from "./Item.vue?vue&type=style&index=0&id=0f0cc77a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0cc77a",
  null
  
)

export default component.exports